import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./vee-validate";
import "./filters";
import "./assets/scss/main.scss";
import vueDebounce from "vue-debounce";
import "./mixins/global.mixin";

Vue.use(require("vue-moment"));
Vue.use(vueDebounce);
Vue.config.productionTip = false;

const EventBus = new Vue();
Vue.prototype.$bus = EventBus;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
